import { xhrRequest } from '../internal/index.js';
import findIndexOfString from './findIndexOfString.js';

function findBoundary(header) {
  for (let i = 0; i < header.length; i++) {
    if (header[i].substr(0, 2) === '--') {
      return header[i];
    }
  }
}

function findContentType(header) {
  for (let i = 0; i < header.length; i++) {
    if (header[i].substr(0, 13) === 'Content-Type:') {
      return header[i].substr(13).trim();
    }
  }
}

function uint8ArrayToString(data, offset = 0, length) {
  const size = length || data.length - offset;

  let str = '';

  for (let i = offset; i < offset + size; i++) {
    str += String.fromCharCode(data[i]);
  }

  return str;
}

function getPixelData(requestUri, imageId, mediaType = 'application/octet-stream') {
  const requestHeaders = {
    Accept: mediaType,
  };

  return new Promise((resolve, reject) => {
    const loadPromise = xhrRequest(requestUri, imageId, requestHeaders);

    loadPromise.then(function (imageFrameAsArrayBuffer /* , xhr*/) {
      // request succeeded, Parse the multi-part mime response
      const imageFrameAsUint8Array = new Uint8Array(imageFrameAsArrayBuffer);

      // First look for the multipart mime header
      const tokenIndex = findIndexOfString(imageFrameAsUint8Array, '\r\n\r\n');

      if (tokenIndex === -1) {
        resolve({
          imageFrame: {
            pixelData: imageFrameAsUint8Array,
          },
        });
        return;
      }
      const headerString = uint8ArrayToString(imageFrameAsUint8Array, 0, tokenIndex);

      // Now find the boundary  marker
      const headers = headerString.split('\r\n');
      const boundary = findBoundary(headers);

      if (!boundary) {
        reject(new Error('invalid response - no boundary marker'));
      }
      const offset = tokenIndex + 4; // skip over the \r\n\r\n

      // find the terminal boundary marker
      const endIndex = findIndexOfString(imageFrameAsUint8Array, boundary, offset);

      if (endIndex === -1) {
        reject(new Error('invalid response - terminating boundary not found'));
      }

      // Remove \r\n from the length
      const length = endIndex - offset - 2;

      // return the info for this pixel data
      resolve({
        contentType: findContentType(headers),
        imageFrame: {
          pixelData: new Uint8Array(imageFrameAsArrayBuffer, offset, length),
        },
      });
    }, reject);
  });
}

export default getPixelData;
